exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReviewForm .RatingStars {\n  font-size: 40px;\n  letter-spacing: 10px;\n}\n", ""]);

// exports
